import { LiFiErrorCode } from '../../errors/constants.js';
import { TransactionError } from '../../errors/errors.js';
export const updateMultisigRouteProcess = async (internalTxHash, step, processType, fromChain, statusManager, multisig) => {
    if (!multisig?.getMultisigTransactionDetails) {
        throw new Error('getMultisigTransactionDetails is missing in multisig config.');
    }
    const updateIntermediateMultisigStatus = () => {
        statusManager.updateProcess(step, processType, 'PENDING');
    };
    const multisigStatusResponse = await multisig?.getMultisigTransactionDetails(internalTxHash, fromChain.id, updateIntermediateMultisigStatus);
    if (multisigStatusResponse.status === 'DONE') {
        statusManager.updateProcess(step, processType, 'PENDING', {
            txHash: multisigStatusResponse.txHash,
            multisigTxHash: undefined,
            txLink: `${fromChain.metamask.blockExplorerUrls[0]}tx/${multisigStatusResponse.txHash}`,
        });
    }
    if (multisigStatusResponse.status === 'FAILED') {
        throw new TransactionError(LiFiErrorCode.TransactionFailed, 'Multisig transaction failed.');
    }
    if (multisigStatusResponse.status === 'CANCELLED') {
        throw new TransactionError(LiFiErrorCode.SignatureRejected, 'Transaction was rejected by user.');
    }
};
//# sourceMappingURL=multisig.js.map